module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00140.64c71ba6.jpg";